import React from "react";

import { connect } from "react-redux";

// component imports

const DocumentReviewSpotlightTag = ({
  type,
  activateClauses,
  dataLoading,
  spotlightIndex,
}) => {
  const NumberOfClauses = spotlightIndex && spotlightIndex.length;

  if (!NumberOfClauses) {
    return null;
  }

  return (
    <div
      onClick={() => activateClauses(type, NumberOfClauses)}
      tabIndex="0"
      role="button"
      onKeyDown={() => {}}
      className="documentreviewlist-tag documentreviewlist-tag-spotlight">
      <div className="documentreviewlist-tag-head">
        <div>
          <span
            role="img"
            aria-label="spotlight-icon"
            className="documentreviewlist-tag-spotlight-icon">
            &#128294;
          </span>
          <span className="documentreviewlist-tag-head-title">
            {type.title}
          </span>
        </div>
        {!dataLoading && (
          <div className="documentreviewlist-tag-head-ctype">
            {NumberOfClauses}
            {"  "}
            {NumberOfClauses === 1 ? "insight" : "insights"}
          </div>
        )}
      </div>
      <div className="documentreviewlist-tag-body">{type.description}</div>
    </div>
  );
};

const mapStateToProps = ({
  MetalensStore: { perDepartmentAnalysisIndex, fullAnalysis, spotlightIndex },
}) => ({
  perDepartmentAnalysisIndex,
  fullAnalysis,
  spotlightIndex,
});

export default connect(mapStateToProps)(DocumentReviewSpotlightTag);
